import { hasLocale } from 'next-intl';

import { routing } from './routing';

/* cspell:disable */
// Language names shown in their own language (autonyms).
export const LOCALE_LABELS = new Map<string, string>([
  ['en', 'English'],
  ['fr', 'Français'],
  ['de', 'Deutsch'],
  ['es', 'Español'],
  ['pt-BR', 'Português (Brasil)'],
  ['ja', '日本語'],
  ['zh-CN', '中文'],
]);
/* cspell:enable */

/**
 * Target path for switching to `next`, stripping any current non-default locale
 * prefix from `currentPath` so reselecting on `/fr` can't produce `/fr/fr`. Pure
 * (no `window`) so it's unit-testable.
 */
export function localeHref(
  next: string,
  currentPath: string,
  search = '',
): string {
  const segments = currentPath.split('/').filter(Boolean);
  const [first, ...rest] = segments;
  const base =
    first !== undefined &&
    first !== routing.defaultLocale &&
    hasLocale(routing.locales, first)
      ? rest
      : segments;
  const parts = next === routing.defaultLocale ? base : [next, ...base];
  return (parts.length > 0 ? `/${parts.join('/')}` : '/') + search;
}

/**
 * Persist the choice for signed-in users (best-effort — `keepalive` lets the
 * write survive the reload, and a 401 for anonymous visitors is ignored), then
 * hard-navigate to the locale's URL. The full reload re-renders the root layout,
 * so the locale, `<html lang>`, Clerk UI language and any switcher value end up
 * correct; a soft navigation leaves them stale.
 */
export function switchLocale(next: string): void {
  void fetch('/api/clerk/locale', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ locale: next }),
    keepalive: true,
  }).catch(() => {
    // best-effort; switching language must still navigate
  });
  window.location.replace(
    localeHref(next, window.location.pathname, window.location.search),
  );
}
